import {Ingredient} from "./ingredient";
import {ProductMeta, ProductSize} from "./product_meta";
import {Menu} from "./menu";
import {PricePipe} from "../pipes/getPrice";

export class Product {
  /**
   * Reference to the parent category
   */
  public price;
  public searchMask = "";
  public category: Menu;
  public id: number;
  public menuOptions;
  public selectedVariation;
  getCategory() {
    return this.category;
  }

  getPayload() {
    return this.payload;
  }

  serialize() {
    return {
      id: this.id,
      initialPayload: this.getPayload(),
      addedIngredients: this.addedIngredients.map(i => i.id),
      removedIngredients: this.removedIngredients.map(i => i.id),
      ingredients: this.ingredients,
      price: this.getCartPrice(),
      category: this.getCategory(),
      image: this.image,
      description: this.description,
      name: this.name,
      number: this.number,
      quantity: this.quantity,
      size: this.meta.getSize(),
      disable_ingredient_change: this.disable_ingredient_change,
      message: this.message,
      menuOptions: this.menuOptions,
      type: this.type,
      menuPriceSpecial: this.menuPriceSpecial,
    };
  }

  static deserialize(payload, category) {

  }

  public ingredientsChanged = false;

  /**
   * Descriptions
   */
  public description: string;

  /**
   * The "id" of the product in the menu card, people may search for this value
   * It's a string because some restaurants uses prefixes.
   */
  public number: string;

  /**
   * Name of the product
   */
  public name: string;

  /**
   * image URL
   */
  public image: any;

  public menuPriceSpecial: number;
  /**
   * current product ingredients (these can be updated in the app)
   */
  public ingredients: Ingredient[];

  /**
   * A list of possible prices (and also sizes)
   */
  public prices: ProductMeta[];

  /**
   * A collection of different variations. This is used for things like dressing and other variations
   */
  public variations: ProductVariation[];

  /**
   * Whether or not user can make changes to the products ingredients
   */
  public disable_ingredient_change;

  /**
   * internal cart id for later removal or edit
   */
  public identifier: number | string;

  public message;

  /**
   * Holds the current product pricedasd
   */
  public meta: ProductMeta;

  public quantity: number = 1;

  public setSize(size: ProductSize) {
    this.meta.setSize(size);
  }

  public setMeta(meta: ProductMeta, index) {
    this.meta = meta;
    this.meta.sizeIndex = index;
    this.meta.priceSet = JSON.parse(JSON.stringify(this.prices));
  }

  /**
   * Holds a copy of the products ingredients to view changes lateron.
   */
  public defaultIngredients: any;
  private payload: ProductPayload;
  public type;
  constructor(payload: ProductPayload, category: Menu) {
    /**
     * for later retrival
     * @type {ProductPayload}
     */
    this.id = payload.id;
    this.payload = payload;
    this.category = category;
    this.image = payload.image;
    this.description = payload.description;
    this.number = payload.number || null;
    this.type = payload.type;
    this.name = payload.name;

    if (payload.ingredients) {
      this.ingredients = Object.keys(payload.ingredients).map((id) => {
        return new Ingredient(payload.ingredients[id]);
      });
    }

    this.prices = payload.prices.map((payload) => {
      return new ProductMeta(payload);
    });


    this.meta = this.prices[0];
    if (this.prices.length > 2) { // klein,groß,familie
      this.meta = this.prices[1]; // groß
    }

    if (payload.variations) {
      this.variations = payload.variations.map((payload) => {
        return new ProductVariation(payload);
      });
    }

    this.disable_ingredient_change = payload.disable_ingredient_change;
    this.message = payload.message;
  }

  public removedIngredients: Ingredient[] = [];
  public addedIngredients: Ingredient[] = [];

  hasChangedIngredients() {
    return (this.addedIngredients.length || this.removedIngredients.length);
  }

  getCartPrice() {
    console.log({menuPriceSpecial: this.menuPriceSpecial, "product": this});
    if (this.menuPriceSpecial) {
      return this.menuPriceSpecial;
    }
    
    if (this.meta) {
      // get price for a single item
      let price = this.meta.getPrice();
      // product has ingredients, let iterate over them
      this.addedIngredients.forEach((ingredient) => {
        if (ingredient.price) {
          price += parseFloat(new PricePipe().transform(ingredient, this.meta.name));
        } else {
          price += this.meta.getIngredientPrice();
        }
      });
      return price * this.quantity;
      //return this.quantity * (this.meta.getPrice() + (this.meta.getIngredientPrice() * this.addedIngredients.length))
    }
  }

  getCartPriceFormatted() {
    let price = this.getCartPrice();

    if (price.toString().indexOf(".") > -1) {
      let suffix = price.toString().split(".");
      if (suffix[1].length == 1) {
        suffix[1] = suffix[1] + "0";
      }
      return suffix.join(",");
    }
    return price.toString() + ",00";
  }

  setIdentifier() {
    const timeStamp = +new Date();
    this.identifier = `${timeStamp}-${this.name}-${Math.random()}`;
  }

  canChangeSize() {
    return this.prices.length > 0;
  }

  /**
   * Changes product based on given variation
   * This is used for crucial changes to the product like dressing or beverage type.
   * Using variations you can also change the product price.
   * @param variation
   * @param result
   */
  setVariation(variation: ProductVariation, result: number) {
    if (!variation){
      return;
    }

    this.selectedVariation = result;
    this.name = `${this.name} (${variation.title})`;
    //this.description = variation.description; //TODO PASCAL WHY DO DIS

    if (variation.addPrice && !variation.overridePrice) {
      this.meta.price += variation.meta.price;
    }

    if (!variation.addPrice && variation.overridePrice) {
      this.meta.price = variation.meta.price;
    }

    if ((variation.addPrice && variation.overridePrice ) || (!variation.addPrice && !variation.overridePrice) ) {
      if(variation.meta) this.meta.price = variation.meta.price;
    }
  }
}


export class ProductVariation {
  public title: string;
  public description: string;
  public addPrice: boolean;
  public overridePrice: boolean;
  public meta?: ProductMeta;

  constructor(payload) {
    this.title = payload.title;
    this.description = payload.description;
    this.addPrice = payload.addPrice;
    this.overridePrice = payload.overridePrice;

    if (payload.price)
      this.meta = new ProductMeta(payload); //TODO payload.price warum?
  }
}

export interface ProductPayload {
  type: "product" | "product-special";
  id: number;
  description: string;
  number: string;
  message: string;
  name: string;
  image: String | boolean;
  disable_ingredient_change: boolean;
  ingredients: Array<Ingredient>;
  prices: Array<Object>;
  variations: Array<Object>;
  addedIngredients?: Array<Ingredient>;
  removedIngredients?: Array<Ingredient>
  payload?: ProductPayload
}



// WEBPACK FOOTER //
// ./src/app/classes/product.ts